import { notes } from 'utils/middleware/notes'
import { filtersSubmit } from './filters'
import { loadBoardPosts } from './loadBoardPosts'
import {
  validateCarrier,
  matchSaferRecords,
  handleOptionsPostSuccess,
  handleResetForm,
} from './options'
import { shipments } from './shipments'
import { sidebar } from './sidebar'

export const appMiddleware = [
  sidebar,
  notes,
  validateCarrier,
  matchSaferRecords,
  handleResetForm,
  handleOptionsPostSuccess,
  filtersSubmit,
  loadBoardPosts,
  shipments,
]
